import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { Flex, Box } from "@chakra-ui/react";
import { FilterInvoiceProps, IFilterInvoice } from "./interface";
import FieldSearch from "../FieldSearch";
import { getInvoiceStatusName } from "../../helpers/global";
import CustomReactSelect from "../CustomReactSelect";
import { InvoiceStatus } from "../../generated/graphql";
import DateRangePicker from "../DateRangePicker";
import { getThisYear } from "../DateRangePicker/data";

const statuses = [
  {
    label: getInvoiceStatusName(InvoiceStatus.Unpaid),
    value: InvoiceStatus.Unpaid,
  },
  {
    label: getInvoiceStatusName(InvoiceStatus.Paid),
    value: InvoiceStatus.Paid,
  },
  {
    label: getInvoiceStatusName(InvoiceStatus.Canceled),
    value: InvoiceStatus.Canceled,
  },
];

const Filter: React.FC<FilterInvoiceProps> = ({ onSubmit, value }) => {
  const { handleSubmit, register, setValue, control } = useForm<IFilterInvoice>(
    {
      defaultValues: {
        dateRange: getThisYear(),
      },
    }
  );

  useEffect(() => {
    setValue("key", value?.key || "");
    setValue("status", value?.status);
    setValue("dateRange", value?.dateRange);
  }, [value, setValue]);

  return (
    <form onSubmit={(e) => e.preventDefault()} autoComplete="off">
      <Box mb={2}>
        <Controller
          control={control}
          name="dateRange"
          render={({ field: { onChange, value } }) => (
            <DateRangePicker
              value={value}
              onSubmit={(e) => {
                onChange(e);
                handleSubmit(onSubmit)();
              }}
            />
          )}
        />
      </Box>
      <Flex alignItems="center" gap={4}>
        <Box>
          <Controller
            name="key"
            control={control}
            render={({ field: { onChange, value } }) => (
              <FieldSearch
                placeholder="Search Invoice / Customer"
                value={value}
                onChange={(e) => {
                  onChange(e);
                  handleSubmit(onSubmit)();
                }}
              />
            )}
          />
        </Box>
        <Box>
          <Controller
            name="status"
            control={control}
            render={({ field: { value, onChange } }) => (
              <CustomReactSelect
                placeholder="All Status"
                size="sm"
                value={statuses.find((elm) => elm.value === value)}
                options={statuses}
                onChange={(value) => {
                  onChange(value?.value as InvoiceStatus);
                  handleSubmit(onSubmit)();
                }}
                isSearchable={false}
                isClearable
              />
            )}
          />
        </Box>
      </Flex>
    </form>
  );
};

export default Filter;
